<template>
  <div :class="['alert', 'alert-' + type]" role="alert">
    {{ message }} <a v-if="link" :href="link">{{ $t('Click Here') }}</a>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AlertMessage',
  props: {
    type: {
      type: String,
      default: 'danger',
      validator(value) {
        return ['danger', 'warning', 'info', 'success'].includes(value);
      }
    },
    message: {
      type: String,
      default: '',
    },
    link: String
  }
}
</script>
